import request from '@/plugins/axios'

/**
 * 获取 FX 游戏配置
 *
 * @returns {Promise} 响应对象，data 为游戏配置
 */
export function getFxConfig() {
	return request({
		url: 'fx/config',
		method: 'GET'
	})
}

/**
 * 获取当日确定性行情种子
 *
 * @returns {Promise} 响应对象，data 为行情种子
 */
export function getMarketSeed() {
	return request({
		url: 'fx/market/seed',
		method: 'GET'
	})
}
